import { useState, useEffect } from 'react';
import axios from 'axios';
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { PrinterIcon  } from '@heroicons/react/24/outline'
  
const apiurl = `${process.env.REACT_APP_API}`;

function numberWithCommas (nStr) {
    nStr += '';
      let x = nStr.split('.');
      let x1 = x[0];
      let x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      x = x1 + x2;
      if(x.substr(0,1) === '.'){
          x = '0' + x;
      }
      return x;
};
  

const ScanPaid = () => {
    const [orders, setOrders] = useState([]);
    const [dailyChart, setDailyChart] = useState(null);
    const [reporttype, setReportType] = useState('');
    const [loading, setLoading] = useState(false);
    const [chartloading, setChartLoading] = useState(false);
    const [dfrom, setDfrom] = useState();
    const [dto, setDto] = useState();
    const [errMsg, setErrMsg] = useState({type:'', info:''});

    function sumtotal(items) {
        return items.reduce((sum, item) => sum + item.Amount * 1, 0);
        // return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
      }
    
      function sumScan(items) {
        return items.reduce((sum, item) => sum + item.ScanQR * 1, 0);
        // return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
      }

    const fetchOrders = async (period) => {
        setLoading(true);
        setReportType(period);
        let qs = "";
        if(period==="scanrange") {
            qs = `period=${period}&dfrom=${dfrom}&dto=${dto}`;
        } else {
            qs = `period=${period}`;
        } 

        try {
            const response = await axios.get(`${apiurl}/reports.php?${qs}`);
            // console.log(response);
            if(response.data.message==="OK") {
                // console.log(response.data.data);
                setOrders(response.data.data);
                setErrMsg({
                    type: '',
                    info: '',
                })
                let charttype = '';
                if(period==='scandaily')
                    charttype = "scancharttoday";
                else if(period==='scansumdaily')
                    charttype = "scanchartdaily";
                else if(period==='scanrange')
                    charttype = "scanchartrange";
                else if(period==='scansumweekly')
                    charttype = "scanchartweekly";
                else 
                    charttype = "cscanhartmonthly";


            //    await fetchOrderChart(charttype);
            }  else {
                setErrMsg({
                    type: 'err',
                    info: 'No record found!!!',
                })
            }
        } catch (error) {
            console.error('Error fetching summary:', error);
        }
        setLoading(false);
    };

    const fetchOrderChart = async (period) => {
        setChartLoading(true);
        // setReportType(period);
        let qs = "";
        if(period==="scanchartrange") {
            qs = `period=${period}&dfrom=${dfrom}&dto=${dto}`;
        } else {
            qs = `period=${period}`;
        } 

        // console.log(qs);
        try {
            const response = await axios.get(`${apiurl}/reports.php?${qs}`);
            // console.log(response);
            if(response.data.message==="OK") {
                // setDailyChart(response.data.data);
                setDailyChart({
                    color: "#8884d8",
                    title: (period==='scancharttoday') ? "Today Chart" : (period==='scanchartrange' || period==='scanchartdaily') ? "Daily Chart" : (period==='scanchartweekly') ? "Weekly Chart" : "Monthly Chart",
                    dataKey: (period==='scancharttoday') ? "cashier" : (period==='scanchartrange' || period==='scanchartdaily') ? "day" : (period==='scanchartweekly') ? "day" : "month",
                    data: response.data.data,
                  });
            }
        } catch (error) {
            console.error('Error fetching summary:', error);
        }
        setChartLoading(false);
    };

    useEffect(() => {
        fetchOrders('scandaily');
      },[])

    // console.log(dailyChart);

    return (
        <div className="flex flex-col p-2 max-w-7xl h-[calc(100vh-140px)] overflow-y-auto mx-auto">
            <div className="flex flex-col md:flex-row p-2 gap-2 items-start justify-between print:hidden">
                <div>
                    <button onClick={() => fetchOrders('scandaily')} className="hover:text-green-500"> ToDay </button> <span> / </span>
                    <button onClick={() => fetchOrders('scansumdaily')} className="hover:text-green-500"> Daily </button> <span> / </span>
                    <button onClick={() => fetchOrders('scansumweekly')} className="hover:text-green-500"> Weekly </button> <span> / </span>
                    <button onClick={() => fetchOrders('scansummonthly')} className="hover:text-green-500"> Monthly </button>
                </div>
                <div  className="flex flex-row col-span-1 gap-2 items-end md:mr-8">
                    <div>
                        <label htmlFor="dfrom" className="block text-sm/6 font-medium text-gray-300">
                            From
                        </label>
                        <input
                            id="dfrom"
                            name="dfrom"
                            value={dfrom}
                            disabled={false}
                            onChange={(e) => setDfrom(e.target.value)}
                            autoComplete="given-date"
                            type="date"
                            className="block sm:w-full rounded-md bg-slate-400 p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                    <div>
                        <label htmlFor="dto" className="block text-sm/6 font-medium text-gray-300">
                            To
                        </label>
                        <input
                            id="dto"
                            name="dto"
                            value={dto}
                            disabled={false}
                            onChange={(e) => setDto(e.target.value)}
                            autoComplete="given-date"
                            type="date"
                            className="block sm:w-full rounded-md bg-slate-400 p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                    <div  className="flex items-end col-span-1 gap-2">
                        <button 
                            type="button" 
                            // disabled={id===0 ? false : true}
                            className="rounded-md bg-teal-800 disabled:bg-slate-500 p-1 mt-2 md:mt-0 text-sm text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => fetchOrders('scanrange')}
                        >
                            Get Item
                        </button>
                    </div>
                </div>            
            </div>
            <div className="print:absolute print:top-0 print:left-0 print:w-full print:h-full print:z-50 print:bg-white print:text-black">
                <span>
                    ScanQR Report
                    <button onClick={() =>window.print()}>
                        <PrinterIcon 
                            className="inline-block h-6 w-6 ml-3 text-sky-500 cursor-pointer hover:text-sky-300"
                        />
                    </button>
                </span>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <div className="flex flex-col max-h-svh overflow-y-auto p-2">
                        <table className="w-full table-auto">
                            <caption className=" caption-bottom text-right py-4 text-lg pr-2">
                                จำนวนครั้ง : {numberWithCommas(sumScan(orders))} <span> ,  </span>
                                จำนวนเงิน : {numberWithCommas(sumtotal(orders))}฿
                            </caption> 
                            <thead>
                            {reporttype==="scansumdaily" || reporttype==="scandaily" || reporttype==="scanrange" ?
                                <tr className="border bg-slate-800">
                                    <th className="border font-normal">Date</th>
                                    <th className="border font-normal">Scan</th>
                                    <th className="border font-normal">Total</th>
                                </tr>
                            : reporttype==="scansumweekly" ?
                                <tr className="border bg-slate-800">
                                    <th className="border">Day</th>
                                    <th className="border">Date</th>
                                    <th className="border">Scan</th>
                                    <th className="border">Total</th>
                                </tr>
                            : <tr className="border bg-slate-800">
                                <th className="border">Year</th>
                                <th className="border">Month</th>
                                <th className="border">Scan</th>
                                <th className="border">Total</th>
                            </tr>
                            }
                            </thead>
                            <tbody>
                            {reporttype==="scansumdaily" || reporttype==="scandaily" || reporttype==="scanrange" ?
                                orders.map((order,i) => (
                                    <tr key={i} className="border odd:bg-blue-500">
                                        <td className="text-center border">{order.date}</td>
                                        <td className="text-center border">{numberWithCommas(order.ScanQR)}</td>
                                        <td className="text-right border pr-2">{numberWithCommas(order.Amount)}฿</td>
                                    </tr>
                                ))
                            : reporttype==="scansumweekly" ?
                                orders.map((order,i) => (
                                    <tr key={i} className="border odd:bg-pink-400">
                                        <td className="text-center border">{order.days}</td>
                                        <td className="text-center border">{order.date}</td>
                                        <td className="text-center border">{numberWithCommas(order.ScanQR)}</td>
                                        <td className="text-right border pr-2">{numberWithCommas(order.Amount)}฿</td>
                                    </tr>
                                ))
                            : orders.map((order,i) => (
                                    <tr key={i} className="border odd:bg-teal-400">
                                        <td className="text-center border">{order.year}</td>
                                        <td className="text-center border">{order.month}</td>
                                        <td className="text-center border">{numberWithCommas(order.ScanQR)}</td>
                                        <td className="text-right border pr-2">{numberWithCommas(order.Amount)}฿</td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>

                        <p className={errMsg.type==='err'? "text-red-600" : "text-green-600"}>
                            {errMsg.info}
                        </p>
                    </div>
                )}
                
                {/* {chartloading ? (
                    <p>Loading...</p>
                ) : ( dailyChart &&
                    <div className="w-full">
                        <h1 className="text-md mt-4">{dailyChart.title}</h1>
                        <div className="">
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart
                                    data={dailyChart.data}
                                    width={500}
                                    height={300}
                                    margin={{
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid stroke="#716e6e" strokeDasharray="3 3" />
                                    <XAxis dataKey={dailyChart.dataKey} stroke="#716e6e" />
                                    <YAxis stroke="#716e6e" />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="Cash" label={dailyChart.data.Cash} stackId="a" fill="#8884d8"  activeBar={<Rectangle fill="pink" stroke="blue" />} />
                                    <Bar dataKey="ScanQR"  label={dailyChart.data.ScanQR} stackId="a" fill="#82ca9d" activeBar={<Rectangle fill="gold" stroke="purple" />} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default ScanPaid;
